import { render, staticRenderFns } from "./add_notice.vue?vue&type=template&id=ab0229fc&scoped=true&"
import script from "./add_notice.vue?vue&type=script&lang=js&"
export * from "./add_notice.vue?vue&type=script&lang=js&"
import style0 from "./add_notice.vue?vue&type=style&index=0&id=ab0229fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0229fc",
  null
  
)

export default component.exports